import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { UPCOMING_INVOICES } from "./apiRoutes";

// --- Define the expected response type ---
export interface UpcomingInvoice {
  schoolName: string;
  installmentNumber: number;
  expectedInvoiceGenerationDate: string;
  installmentAmount: number;
  pdcStatus: boolean;
  invoiceGeneration: boolean;
}

export interface UpcomingInvoicesResponse {
  data: {
    items: UpcomingInvoice[];
  };
}

// --- Fetch function ---
const fetchUpcomingInvoices = async (): Promise<UpcomingInvoicesResponse> => {
  const response = await axiosAuth.get<UpcomingInvoicesResponse>(UPCOMING_INVOICES);
  return response.data;
};

// --- React Query Hook ---
export const useGetUpcomingInvoicesQuery = (
  queryParams?: UseQueryOptions<
    UpcomingInvoicesResponse,
    Error,
    UpcomingInvoicesResponse,
    ["upcomingInvoices"]
  >
) =>
  useQuery<
    UpcomingInvoicesResponse,
    Error,
    UpcomingInvoicesResponse,
    ["upcomingInvoices"]
  >({
    queryKey: ["upcomingInvoices"],
    queryFn: fetchUpcomingInvoices,
    ...(queryParams as any),
  });
